import React, { useState, useEffect } from 'react';
import { makeStyles } from "@mui/styles";
import { Table, TableHead, TableBody, TableCell, TableContainer, TableRow, TablePagination, Collapse, Select, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
// import StockTableRow from './StockTableRow';
// import { FilterListOff } from "@mui/icons-material";
// import { ArrowDownward, ArrowUpward, CameraAlt, FilterList } from "@mui/icons-material";
// import { Search } from "lucide-react";
import { eventHistoryTableColumns } from '../../../Config/constants';
// import FlagstoneTheme from '../../../Config/flagstoneTheme';

// import AddIcon from '@mui/icons-material/Add';
import { Spin } from "react-cssfx-loading";
import { connect } from 'react-redux';
import { Search, Check, X } from 'lucide-react';

export const EventHistoryOverviewTable = (props) => {
    const classes = useStyles();

    const { t } = useTranslation();
    const [pg, setpg] = React.useState(0);
    const [rpg, setrpg] = React.useState(25);
    const [filteredEventHistory, setFilteredEventHistory] = useState([]);
    const [localEventHistory, setLocalEventHistory] = useState([]);
    const [filterValues, setFilterValues] = useState([
        { type: eventHistoryTableColumns.EVENTDATE, value: "" },
        { type: eventHistoryTableColumns.EVENTTYPE, value: "" },
        { type: eventHistoryTableColumns.SSCC, value: "" },
        { type: eventHistoryTableColumns.PRODUCTNUMBER, value: "" },
        { type: eventHistoryTableColumns.PRODUCTDESCRIPTION, value: "" },
        { type: eventHistoryTableColumns.CHECKPOINT, value: "" },
        { type: eventHistoryTableColumns.USERNAME, value: "" },
        { type: eventHistoryTableColumns.SUCCEEDED, value: "" }
    ]);
    const [noHistoryFound, setNoHistoryFound] = useState(false);

    useEffect(() => {
        let tempEventHistory = props.eventHistory.map(x => ({
            ...x,
            visible: true
        }));
        setLocalEventHistory(tempEventHistory);
        setFilteredEventHistory(tempEventHistory);
    }, [props.eventHistory]);

    useEffect(() => {
        if (!props.showFilters) {
            handleRemoveFilters();
        }
    }, [props.showFilters]);

    function handleChangePage(event, newpage) {
        setpg(newpage);
    }

    function handleChangeRowsPerPage(event) {
        setrpg(parseInt(event.target.value));
        setpg(0);
    }

    const formatDate = (date) => {
        let d = new Date(date);

        let optionsDate = { day: '2-digit', month: '2-digit', year: 'numeric' };
        let optionsTime = { hour: '2-digit', minute: '2-digit' };

        let dateString = d.toLocaleDateString('en-GB', optionsDate).replace(/\//g, '-');
        let timeString = d.toLocaleTimeString('en-GB', optionsTime);

        return dateString + " (" + timeString + ")";
    }

    const formatSuccess = (succeeded) => {
        if (succeeded === null) {
            return <X size={24} color="#D84949" />;
        } else {
            return JSON.parse(succeeded.toLowerCase()) ? <Check size={24} color="#5CC958" /> : <X size={24} color="#D84949" />;
        }
    }

    const handleRemoveFilters = () => {
        let tempEventHistory = props.eventHistory.map(x => ({
            ...x,
            visible: true
        }));

        setFilterValues([
            { type: eventHistoryTableColumns.EVENTDATE, value: "" },
            { type: eventHistoryTableColumns.EVENTTYPE, value: "" },
            { type: eventHistoryTableColumns.SSCC, value: "" },
            { type: eventHistoryTableColumns.PRODUCTNUMBER, value: "" },
            { type: eventHistoryTableColumns.PRODUCTDESCRIPTION, value: "" },
            { type: eventHistoryTableColumns.CHECKPOINT, value: "" },
            { type: eventHistoryTableColumns.USERNAME, value: "" },
            { type: eventHistoryTableColumns.SUCCEEDED, value: "" }
        ])

        setFilteredEventHistory(tempEventHistory);
    }

    const handleSearch = (e, column) => {
        let value;

        value = e.target.value

        let tempFilterValues = [...filterValues];

        if (tempFilterValues.some(x => x.type === column)) {
            tempFilterValues.find(x => x.type === column).value = value;
        } else {
            tempFilterValues.push({ type: column, value: value });
        }

        let filterPresent = false;

        tempFilterValues.map(filterValue => {
            if (filterValue.value !== null && (filterValue.value.length > 0 || filterValue.value == true)) {
                filterPresent = true;
            }
        })

        if (!filterPresent) {
            tempFilterValues = [
                { type: eventHistoryTableColumns.EVENTDATE, value: "" },
                { type: eventHistoryTableColumns.EVENTTYPE, value: "" },
                { type: eventHistoryTableColumns.SSCC, value: "" },
                { type: eventHistoryTableColumns.PRODUCTNUMBER, value: "" },
                { type: eventHistoryTableColumns.PRODUCTDESCRIPTION, value: "" },
                { type: eventHistoryTableColumns.CHECKPOINT, value: "" },
                { type: eventHistoryTableColumns.USERNAME, value: "" },
                { type: eventHistoryTableColumns.SUCCEEDED, value: "" }
            ]
        }

        filterEventHistory(tempFilterValues);
        setFilterValues(tempFilterValues);
    }

    const filterEventHistory = (filterValues) => {
        let tempEventHistory = JSON.parse(JSON.stringify(localEventHistory))

        filterValues.forEach(filterValue => {
            var value = filterValues.find(x => x.type === filterValue.type).value;
            switch (filterValue.type) {
                case eventHistoryTableColumns.EVENTDATE:
                    if (value !== null && value !== "") {
                        let filterDate = new Date(value);

                        tempEventHistory.map(x => {
                            if (x.eventDate) {
                                let date = new Date(x.eventDate);
                                if (date.toDateString() !== filterDate.toDateString()) {
                                    x.visible = false;
                                }
                            } else {
                                x.visible = false;
                            }
                        });
                    }
                    break;
                case eventHistoryTableColumns.EVENTTYPE:
                    if (value !== null && value !== "") {
                        tempEventHistory.map(x => { if (x.eventType) { if (!x.eventType.toLowerCase().includes(value.toLowerCase())) { x.visible = false } } else { x.visible = false } })
                    }
                    break;
                case eventHistoryTableColumns.SSCC:
                    if (value !== null && value !== "") {
                        tempEventHistory.map(x => { if (x.sscc) { if (!x.sscc.toString().toLowerCase().includes(value.toString().toLowerCase())) { x.visible = false; } } else { x.visible = false } });
                    }
                    break;
                case eventHistoryTableColumns.PRODUCTNUMBER:
                    if (value !== null && value !== "") {
                        tempEventHistory.map(x => { if (x.productNumber) { if (!x.productNumber.toString().toLowerCase().includes(value.toString().toLowerCase())) { x.visible = false; } } else { x.visible = false } });
                    }
                    break;
                case eventHistoryTableColumns.USERNAME:
                    if (value !== null && value !== "") {
                        tempEventHistory.map(x => { if (x.userName) { if (!x.userName.toString().toLowerCase().includes(value.toString().toLowerCase())) { x.visible = false; } } else { x.visible = false } });
                    }
                    break;
                case eventHistoryTableColumns.PRODUCTNUMBER:
                    if (value !== null && value !== "") {
                        tempEventHistory.map(x => { if (x.productNumber) { if (!x.productNumber.toString().toLowerCase().includes(value.toLowerCase())) { x.visible = false; } } else { x.visible = false } });
                    }
                    break;
                case eventHistoryTableColumns.PRODUCTDESCRIPTION:
                    if (value !== null && value !== "") {
                        tempEventHistory.map(x => {
                            if (x.productDescription) { if (!x.productDescription.toString().toLowerCase().includes(value.toString().toLowerCase())) { x.visible = false; } } else { x.visible = false }
                        });
                    }
                    break;
                case eventHistoryTableColumns.CHECKPOINT:
                    if (value !== null && value !== "") {
                        tempEventHistory.map(x => {
                            if (x.workstation) { if (!x.workstation.toString().toLowerCase().includes(value.toString().toLowerCase())) { x.visible = false; } } else { x.visible = false }
                        });
                    }
            }
        });
        setFilteredEventHistory(tempEventHistory);
    }

    return (
        <React.Fragment>
            {props.loading ? <div className={classes.loadingBalls}><Spin width="100px" height="100px" color="#4654FB"></Spin></div> :
                <div className={classes.tableContainer}>
                    <React.Fragment>
                        <TableContainer className={classes.tableContainer}>
                            <Table className={classes.table} aria-label="customized table">
                                <TableHead className={classes.head}>
                                    {/* Filters */}
                                    <TableRow className={classes.head__filterRow}>
                                        <TableCell className={classes.head__filterCell}>
                                            <Collapse in={props.showFilters} timeout={200} className={classes.head__collapse}>
                                                <input className={classes.head__filterInput_date} type="date" value={filterValues[eventHistoryTableColumns.EVENTDATE].value} onChange={(e) => handleSearch(e, eventHistoryTableColumns.EVENTDATE)} />
                                            </Collapse>
                                        </TableCell>
                                        <TableCell className={classes.head__filterCell} >
                                            <Collapse in={props.showFilters} timeout={200} className={classes.head__collapse}>
                                                <div className={classes.head__filterInputContainer}>
                                                    <Search size={12} className={classes.head__filterInputIcon} />
                                                    <input className={classes.head__filterInput} type="text" value={filterValues[eventHistoryTableColumns.EVENTTYPE].value} onChange={(e) => handleSearch(e, eventHistoryTableColumns.EVENTTYPE)} />
                                                </div>
                                            </Collapse>
                                        </TableCell>
                                        <TableCell className={classes.head__filterCell}>
                                            <Collapse in={props.showFilters} timeout={200} className={classes.head__collapse}>
                                                <div className={classes.head__filterInputContainer}>
                                                    <Search size={12} className={classes.head__filterInputIcon} />
                                                    <input className={classes.head__filterInput} type="text" value={filterValues[eventHistoryTableColumns.SSCC].value} onChange={(e) => handleSearch(e, eventHistoryTableColumns.SSCC)} />
                                                </div>
                                            </Collapse>
                                        </TableCell>
                                        <TableCell className={classes.head__filterCell}>
                                            <Collapse in={props.showFilters} timeout={200} className={classes.head__collapse}>
                                                <div className={classes.head__filterInputContainer}>
                                                    <Search size={12} className={classes.head__filterInputIcon} />
                                                    <input className={classes.head__filterInput} type="text" value={filterValues[eventHistoryTableColumns.PRODUCTNUMBER].value} onChange={(e) => handleSearch(e, eventHistoryTableColumns.PRODUCTNUMBER)} />
                                                </div>
                                            </Collapse>
                                        </TableCell>
                                        <TableCell className={classes.head__filterCell}>
                                            <Collapse in={props.showFilters} timeout={200} className={classes.head__collapse}>
                                                <div className={classes.head__filterInputContainer}>
                                                    <Search size={12} className={classes.head__filterInputIcon} />
                                                    <input className={classes.head__filterInput} type="text" value={filterValues[eventHistoryTableColumns.PRODUCTDESCRIPTION].value} onChange={(e) => handleSearch(e, eventHistoryTableColumns.PRODUCTDESCRIPTION)} />
                                                </div>
                                            </Collapse>
                                        </TableCell>
                                        <TableCell className={classes.head__filterCell}>
                                            <Collapse in={props.showFilters} timeout={200} className={classes.head__collapse}>
                                                <Select
                                                    value={filterValues[eventHistoryTableColumns.CHECKPOINT].value}
                                                    onChange={(e) => handleSearch(e, eventHistoryTableColumns.CHECKPOINT)}
                                                    displayEmpty
                                                    className={classes.head__filterSelect}
                                                    sx={{
                                                        '& .MuiSelect-select': {
                                                            padding: 0,
                                                        }
                                                    }}
                                                >
                                                    <MenuItem value="">All</MenuItem>
                                                    {props.checkpoints.map((checkpoint, index) => (
                                                        <MenuItem key={index} value={checkpoint.name}>{checkpoint.name}</MenuItem>
                                                    ))}
                                                </Select>
                                            </Collapse>
                                        </TableCell>
                                        <TableCell className={classes.head__filterCell}>
                                            <Collapse in={props.showFilters} timeout={200} className={classes.head__collapse}>
                                                <div className={classes.head__filterInputContainer}>
                                                    <Search size={12} className={classes.head__filterInputIcon} />
                                                    <input className={classes.head__filterInput} type="text" value={filterValues[eventHistoryTableColumns.USERNAME].value} onChange={(e) => handleSearch(e, eventHistoryTableColumns.USERNAME)} />
                                                </div>
                                            </Collapse>
                                        </TableCell>
                                    </TableRow>

                                    {/* Headers */}
                                    <TableRow className={classes.head__headerRow}>
                                        <TableCell className={classes.head__headCell} style={{ width: '12%' }}>
                                            {t("Event date")}
                                            {/* <ArrowUpward className={classes.arrowUp} style={{ color: getGroupingIconColor(historyTableColumns.QUANTITY, true) }} onClick={() => props.handleGrouping(historyTableColumns.QUANTITY, true)}></ArrowUpward>
                                            <ArrowDownward className={classes.arrowDown} style={{ color: getGroupingIconColor(historyTableColumns.QUANTITY, false) }} onClick={() => props.handleGrouping(historyTableColumns.QUANTITY, false)}></ArrowDownward> */}
                                        </TableCell>
                                        <TableCell className={classes.head__headCell} style={{ width: '12%' }}>
                                            {t("Event type")}
                                            {/* <ArrowUpward className={classes.arrowUp} style={{ color: getGroupingIconColor(historyTableColumns.PRODUCT, true) }} onClick={() => props.handleGrouping(historyTableColumns.PRODUCT, true)}></ArrowUpward>
                                            <ArrowDownward className={classes.arrowDown} style={{ color: getGroupingIconColor(historyTableColumns.PRODUCT, false) }} onClick={() => props.handleGrouping(historyTableColumns.PRODUCT, false)}></ArrowDownward> */}
                                        </TableCell>
                                        <TableCell className={classes.head__headCell} style={{ width: '12%' }}>
                                            {t("SSCC")}
                                            {/* <ArrowUpward className={classes.arrowUp} style={{ color: getGroupingIconColor(historyTableColumns.BARCODE, true) }} onClick={() => props.handleGrouping(historyTableColumns.BARCODE, true)}></ArrowUpward>
                                            <ArrowDownward className={classes.arrowDown} style={{ color: getGroupingIconColor(historyTableColumns.BARCODE, false) }} onClick={() => props.handleGrouping(historyTableColumns.BARCODE, false)}></ArrowDownward> */}
                                        </TableCell>
                                        <TableCell className={classes.head__headCell} style={{ width: '12%' }}>
                                            {t("Product nr.")}
                                            {/* <ArrowUpward className={classes.arrowUp} style={{ color: getGroupingIconColor(historyTableColumns.ORDER, true) }} onClick={() => props.handleGrouping(historyTableColumns.ORDER, true)}></ArrowUpward>
                                            <ArrowDownward className={classes.arrowDown} style={{ color: getGroupingIconColor(historyTableColumns.ORDER, false) }} onClick={() => props.handleGrouping(historyTableColumns.ORDER, false)}></ArrowDownward> */}
                                        </TableCell>
                                        <TableCell className={classes.head__headCell} style={{ width: '25%' }}>
                                            {t("Product description")}
                                            {/* <ArrowUpward className={classes.arrowUp} style={{ color: getGroupingIconColor(historyTableColumns.LOCATION, true) }} onClick={() => props.handleGrouping(historyTableColumns.LOCATION, true)}></ArrowUpward>
                                            <ArrowDownward className={classes.arrowDown} style={{ color: getGroupingIconColor(historyTableColumns.LOCATION, false) }} onClick={() => props.handleGrouping(historyTableColumns.LOCATION, false)}></ArrowDownward> */}
                                        </TableCell>
                                        <TableCell className={classes.head__headCell} style={{ width: '10%' }} >
                                            {t("Checkpoint")}
                                            {/* <ArrowUpward className={classes.arrowUp} style={{ color: getGroupingIconColor(historyTableColumns.PALLET, true) }} onClick={() => props.handleGrouping(historyTableColumns.PALLET, true)}></ArrowUpward>
                                            <ArrowDownward className={classes.arrowDown} style={{ color: getGroupingIconColor(historyTableColumns.PALLET, false) }} onClick={() => props.handleGrouping(historyTableColumns.PALLET, false)}></ArrowDownward> */}
                                        </TableCell>
                                        <TableCell className={classes.head__headCell} style={{ width: '12%' }}>
                                            {t("User")}
                                            {/* <ArrowUpward className={classes.arrowUp} style={{ color: getGroupingIconColor(historyTableColumns.QUALITY, true) }} onClick={() => props.handleGrouping(historyTableColumns.QUALITY, true)}></ArrowUpward>
                                            <ArrowDownward className={classes.arrowDown} style={{ color: getGroupingIconColor(historyTableColumns.QUALITY, false) }} onClick={() => props.handleGrouping(historyTableColumns.QUALITY, false)}></ArrowDownward> */}
                                        </TableCell>
                                        <TableCell className={classes.head__headCell} style={{ width: '5%', textAlign: 'center' }} >
                                            {t("Success")}
                                            {/* <ArrowUpward className={classes.arrowUp} style={{ color: getGroupingIconColor(historyTableColumns.PALLET, true) }} onClick={() => props.handleGrouping(historyTableColumns.PALLET, true)}></ArrowUpward>
                                            <ArrowDownward className={classes.arrowDown} style={{ color: getGroupingIconColor(historyTableColumns.PALLET, false) }} onClick={() => props.handleGrouping(historyTableColumns.PALLET, false)}></ArrowDownward> */}
                                        </TableCell>
                                    </TableRow>
                                </TableHead>

                                {props.eventHistory.length > 0 ?
                                    <TableBody className={classes.body}>
                                        {filteredEventHistory.filter(x => x.visible).slice(pg * rpg, pg * rpg + rpg).map((row, index) => (
                                            <TableRow key={index} className={classes.body__row}>
                                                <TableCell className={classes.body__cell}>{formatDate(row.eventDate)}</TableCell>
                                                <TableCell className={classes.body__cell}>{row.eventType}</TableCell>
                                                <TableCell className={classes.body__cell}>{row.sscc}</TableCell>
                                                <TableCell className={classes.body__cell}>{row.productNumber}</TableCell>
                                                <TableCell className={classes.body__cell} style={{ minWidth: '350px' }}>{row.productDescription}</TableCell>
                                                <TableCell className={classes.body__cell}>{row.workstation}</TableCell>
                                                <TableCell className={classes.body__cell}>{row.userName}</TableCell>
                                                <TableCell className={classes.body__cell} style={{ textAlign: 'center' }}>{formatSuccess(row.succeeded)}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                    : null}
                            </Table>
                        </TableContainer>
                        {noHistoryFound ?
                            null
                            :
                            <TablePagination
                                rowsPerPageOptions={[25, 50, 100]}
                                component="div"
                                count={filteredEventHistory.filter(x => x.visible).length}
                                // translations
                                labelRowsPerPage={t("Rows per page")}
                                labelDisplayedRows={({ from, to, count }) => `${from}-${to} ${t("of")} ${count}`}
                                rowsPerPage={rpg}
                                page={pg}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        }
                    </React.Fragment>
                    {props.eventHistory.length > 0 ? null :
                        <div className={classes.emptyStateContainer}>
                            <p className={classes.emptyState__text}>
                                {t("No event history found")}.
                            </p>
                        </div>
                    }
                    {noHistoryFound ?
                        <div className={classes.emptyStateContainer}>
                            <p className={classes.emptyState__text}>{t("No event history found")}.</p>
                        </div>
                        :
                        null
                    }
                </div>
            }
        </React.Fragment >
    )


}

const useStyles = makeStyles({

    paper: {
        boxShadow: 'none',
        backgroundColor: 'transparent',
    },

    title: {
        fontSize: "22px",
        fontFamily: "Lato, sans-serif !important",
        fontWeight: 'medium',
        color: "#020100",
        float: "left",
        marginBottom: "10px",
        paddingLeft: "20px",
        marginTop: "15px"
    },

    head: {

    },

    head__filterRow: {
        height: 'fit-content',
    },

    collapse: {
        float: "left",
        width: "100%",
    },

    head__filterCell: {
        padding: "0px 0px 8px 24px !important",


        "&:first-child": {
            paddingLeft: "14px !important",
        },

        "&:last-child": {
            paddingRight: "14px !important",
        },
    },

    head__filterInputContainer: {
        position: 'relative',
    },

    head__filterInputIcon: {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        left: '8px',
    },

    head__filterInput: {
        width: '100%',
        height: '28px',
        borderRadius: '3px',
        border: '1px solid #A9A9A9',

        padding: '0px 8px',
        paddingLeft: '24px',
        boxSizing: 'border-box',

        fontSize: '16px',
        fontFamily: 'Lato, sans-serif !important',
        fontWeight: 'regular',
        color: '#0C0E29',

        "&:focus": {
            outline: "none",
            border: "1px solid #4654FB",
        },
    },

    head__filterSelect: {
        width: '100%',
        height: '28px',
        borderRadius: '3px !important',
        border: '1px solid #A9A9A9 !important',

        padding: '0px 8px',
        boxSizing: 'border-box !important',

        fontSize: '16px !important',
        fontFamily: 'Lato, sans-serif !important',
        fontWeight: 'normal !important',
        color: '#0C0E29 !important',

        backgroundColor: 'white',

        "&:focus": {
            outline: "none",
            border: "1px solid #4654FB",
        },
    },

    head__filterInput_date: {
        width: '100%',
        height: '28px',
        borderRadius: '3px',
        border: '1px solid #A9A9A9',

        padding: '0px 8px',
        boxSizing: 'border-box',

        fontSize: '16px',
        fontFamily: 'Lato, sans-serif !important',
        fontWeight: 'regular',
        color: '#0C0E29',

        "&:focus": {
            outline: "none",
            border: "1px solid #4654FB",
        },
    },

    head__headerRow: {
        backgroundColor: '#E2E4F5',
        borderRadius: "6px",
    },

    head__headCell: {
        fontSize: "16px !important",
        fontFamily: "Lato, sans-serif !important",
        fontWeight: "bold !important",
        color: "#0C0E29",

        padding: "8px 24px !important",
        paddingTop: "0px",
        border: "none",

        "&:first-child": {
            borderRadius: "6px 0 0 6px",
            paddingLeft: "14px !important",
        },

        "&:last-child": {
            borderRadius: "0 6px 6px 0",
            paddingRight: "14px !important",
        },
    },

    body: {

    },

    body__row: {
        "&:nth-of-type(even)": {
            backgroundColor: "#F7F7F7",
            mixBlendMode: "multiply",
        },
    },

    body__cell: {
        fontSize: "16px !important",
        fontFamily: "Lato, sans-serif !important",
        fontWeight: "medium",
        color: "#0C0E29",

        padding: "8px 24px !important",
        paddingTop: "0px",
        border: "none",

        "&:first-child": {
            borderRadius: "6px 0 0 6px",
            paddingLeft: "14px !important",
        },

        "&:last-child": {
            borderRadius: "0 6px 6px 0",
            paddingRight: "14px !important",
        },
    },

    emptyStateContainer: {
        width: '100%',

        textAlign: "center",
        marginTop: "192px",
    },

    emptyState__text: {
        fontSize: "24px",
        fontFamily: "Lato, sans-serif !important",
        fontWeight: "medium",
        color: "#0C0E29",
    },



    tableContainer: {
        height: "auto"
    },
    row: {
        '&:nth-of-type(odd)': {
            backgroundColor: "#F4F4F4",
        },
    },
    table: {
        borderSpacing: '0px 5px',
        borderCollapse: 'separate',
    },

    arrowUp: {
        width: "15px",
        marginLeft: "10px",
        position: "relative",
        top: 7,
        cursor: "pointer"
    },
    arrowDown: {
        width: "15px",
        position: "relative",
        top: 7,
        cursor: "pointer"
    },
    loadingBalls: {
        height: '100%',
        display: 'flex',
        // alignContent: 'center',
        // alignItems: 'center',
        justifyContent: 'center',
    },
});

function mapStateToProps(state) {
    return {
        workstation: state.workstation,
        general: state.general,
        user: state.user
    }
}

export default connect(mapStateToProps)(EventHistoryOverviewTable)